/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OEX API
 * Operators Exchange REST API (docs/08). Org-scoped routes take the active organisation in X-Org-Id; errors are RFC 7807 problem details with a `code`.
 * OpenAPI spec version: 1
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  ChatReplyDto,
  ChatRequestDto
} from '../../model';

import { oexFetch } from '../../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getAssistantChatUrl = () => {




  return `/v1/assistant/chat`
}

/**
 * @summary Ask Exxy, the in-app help assistant, a question about using OEX
 */
export const assistantChat = async (chatRequestDto: ChatRequestDto, options?: Parameters<typeof oexFetch>[1]): Promise<ChatReplyDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return oexFetch<ChatReplyDto>(getAssistantChatUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(chatRequestDto)
  }
);}





export const getAssistantChatMutationKey = () => ['assistantChat'] as const;

export const getAssistantChatMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assistantChat>>, TError,AssistantChatMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assistantChat>>, TError,AssistantChatMutationVariables, TContext> => {

const mutationKey = getAssistantChatMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assistantChat>>, AssistantChatMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  assistantChat(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssistantChatMutationResult = NonNullable<Awaited<ReturnType<typeof assistantChat>>>
    export type AssistantChatMutationBody = ChatRequestDto
    export type AssistantChatMutationError = unknown
    export type AssistantChatMutationVariables = {data: ChatRequestDto}

    /**
 * @summary Ask Exxy, the in-app help assistant, a question about using OEX
 */
export const useAssistantChat = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assistantChat>>, TError,AssistantChatMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assistantChat>>,
        TError,
        AssistantChatMutationVariables,
        TContext
      > => {
      return useMutation(getAssistantChatMutationOptions(options), queryClient);
    }
